import { excerpt, StreamProtocolError } from './stream.ts';

/** Yields each `data:` payload of an SSE body as it arrives. Any other non-empty line throws. */
export async function* readEventStream(body: ReadableStream<Uint8Array>): AsyncGenerator<string> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';
      for (const raw of lines) {
        const line = raw.endsWith('\r') ? raw.slice(0, -1) : raw;
        if (line === '') continue;
        if (!line.startsWith('data:')) throw new StreamProtocolError(`The server sent a line that is not an SSE data field: ${excerpt(line)}`);
        yield line.slice(5).trimStart();
      }
    }
    buffer += decoder.decode();
    if (buffer.trim() !== '') throw new StreamProtocolError(`The stream ended inside an event: ${excerpt(buffer)}`);
  } finally {
    reader.releaseLock();
  }
}
